"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_hooks_1 = require("@apollo/react-hooks");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const formik_1 = require("formik");
const react_1 = tslib_1.__importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const reactstrap_1 = require("reactstrap");
const AjaxButton_1 = require("./AjaxButton");
const BottomToolbar_1 = require("./BottomToolbar");
const react_2 = require("@osmosys/react");
function Form(props) {
    const { formikProps, mutationProps, stopOnSubmit } = props;
    const fProps = formikProps;
    const { mutation } = mutationProps, subsetOfMutationProps = tslib_1.__rest(mutationProps, ["mutation"]);
    const [mutationFunc, mutationResult] = react_hooks_1.useMutation(mutation, Object.assign({}, subsetOfMutationProps));
    return (react_1.default.createElement(formik_1.Formik, Object.assign({ onSubmit: (values, formikActions) => {
            // Blur on submit
            if (props.blurOnSubmit) {
                if (document.activeElement instanceof HTMLElement) {
                    document.activeElement.blur();
                }
            }
            // On submit callback
            if (props.onSubmit) {
                props.onSubmit(values, formikActions);
                if (stopOnSubmit) {
                    return;
                }
            }
            // Mutate
            mutationFunc({
                variables: props.valuesToVariables(values),
            })
                .catch(e => {
                formikActions.setSubmitting(false);
                throw e;
            })
                .then(() => {
                formikActions.setSubmitting(false);
            });
        } }, fProps), formikInnerProps => (react_1.default.createElement(reactstrap_1.Form, { onSubmit: formEvent => {
            formikInnerProps.handleSubmit(formEvent);
        }, className: props.className },
        react_1.default.createElement(reactstrap_1.Collapse, { isOpen: !!(mutationResult.data &&
                (props.renderSuccess || props.showCheckIconOnSuccess)), className: !!(mutationResult.data &&
                (props.renderSuccess || props.showCheckIconOnSuccess)) && props.collapseClassName }, mutationResult.data &&
            (props.renderSuccess || props.showCheckIconOnSuccess) && (react_1.default.createElement(react_1.default.Fragment, null, props.showCheckIconOnSuccess && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: classnames_1.default('text-center my-2', props.successWrapperClassName) },
                react_1.default.createElement("h2", null,
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faCheck })),
                props.successMessage && (react_1.default.createElement("p", { className: "font-weight-bold" }, props.successMessage(mutationResult.data)))),
            props.renderSuccess &&
                props.renderSuccess(mutationResult.data, formikInnerProps),
            react_1.default.createElement("div", { className: "text-center", "data-cy": "form-success-actions" }, props.successActions &&
                props.successActions(mutationResult.data).map(a => (react_1.default.createElement(react_1.default.Fragment, { key: a.label },
                    react_1.default.createElement(reactstrap_1.Button, { color: a.color || 'light', onClick: a.onClick ? () => a.onClick() : undefined, tag: a.to ? react_router_dom_1.Link : undefined, to: a.to ? a.to : undefined },
                        a.icon && (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: a.icon, className: "mr-2" })),
                        a.label),
                    ' '))))))))),
        react_1.default.createElement(reactstrap_1.Collapse, { isOpen: !(mutationResult.data &&
                (props.renderSuccess || props.showCheckIconOnSuccess)), className: props.collapseClassName },
            props.children(formikInnerProps, mutationResult),
            props.ajaxbuttonProps && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(AjaxButton_1.AjaxButton, Object.assign({}, props.ajaxbuttonProps(mutationResult), { type: "submit", onClick: () => {
                        formikInnerProps.handleSubmit();
                    } })),
                react_1.default.createElement(react_2.OsmosysErrorAlert
                // hideWarningIcon
                , { 
                    // hideWarningIcon
                    apolloError: mutationResult.error })))),
        props.showBottomToolbar === true &&
            !(mutationResult.data &&
                (props.renderSuccess || props.showCheckIconOnSuccess)) && (react_1.default.createElement(BottomToolbar_1.BottomToolbar, { left: react_1.default.createElement(react_2.OsmosysErrorAlert
            // dismissable
            // hideWarningIcon
            , { 
                // dismissable
                // hideWarningIcon
                apolloError: mutationResult.error }), right: react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(react_2.OsmosysButton, { osysName: "Form.Save", mutationResult: mutationResult, disabled: mutationResult.loading, type: "submit", tooltip: !formikInnerProps.dirty
                        ? 'No changes to save'
                        : mutationResult.loading
                            ? 'Loading...'
                            : !formikInnerProps.dirty && !formikInnerProps.isValid
                                ? 'This form is not ready to be submitted. Please ensure it is filled out and has valid entries.'
                                : 'Submit', mutate: () => {
                        formikInnerProps.handleSubmit();
                    }, osysStyle: "save", renderApolloError: false }, props.saveButtonText || 'Save')) }))))));
}
exports.Form = Form;
//# sourceMappingURL=Form.js.map